export default "__VITE_ASSET__k$ppx0Vo__"